import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function AnmeldelserPage() {
  const [reviewsList, setReviewsList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef(null);

  const defaultReviews = [
    {
      name: 'Henriette Bläske',
      date_info: 'God pris',
      comment: 'Jeg har gået ved Tine til massage i lidt over et år nu, og er fornyligt begyndt ved Sophie til zoneterapi, og jeg må sige at begge behandlere er kompetente i deres arbejde, og jeg har kun god erfaring med dem begge. Jeg er især overrasket over effekten af zoneterapien, som har hjulpet med min søvn, spændinger i kroppen, samt bivirkninger af medicin.',
      rating: 5,
    },
    {
      name: 'Yvonne Jensen',
      date_info: 'God pris',
      comment: 'Vil klar anbefaler dette sted god massage og så har de også zoneterapi som også er en god oplevelse 😊',
      rating: 5,
    },
    {
      name: 'Kathrin Savace',
      date_info: 'Fantastisk resultat',
      comment: 'Tine er en fantastisk dygtig og rar massør. Hun hjalp mig af med en ond hold i nakken og ryg. Top professionel og dygtig massør - min varmeste og bedste anbefaling 🌟🌟🌟🌟🌟🌟❤️',
      rating: 5,
    },
    {
      name: 'Malene Adelsböll Nikolajsen',
      date_info: 'De bedste anbefalinger',
      comment: 'Kan helt klart anbefale at bruge Djurs Massage. Har både fået massage, kopper, nåle og ultralyd hos hende. Det er et besøg. De bedste anbefalinger herfra. ⭐️⭐️⭐️⭐️⭐️',
      rating: 5,
    },
  ];

  useEffect(() => {
    fetch('/_api/public/v2/content/anmeldelser')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data && data.items && data.items.length > 0) {
          const mapped = data.items
            .filter((item) => {
              const text = (item.anmeldelse || item.comment || '').toLowerCase();
              return !text.includes('h-jewelry') && !text.includes('smykk');
            })
            .map((item) => ({
            ...item,
            name: item.navn || item.name,
            comment: item.anmeldelse || item.comment,
            date_info: item.tidspunkt || item.date_info,
            rating: item.stjerner || item.rating || 5,
          }));
          setReviewsList(mapped);
        } else {
          setReviewsList(defaultReviews);
        }
      })
      .catch(() => setReviewsList(defaultReviews));
  }, []);

  const items = reviewsList.length > 0 ? reviewsList : defaultReviews;
  const count = items.length;

  // Auto slide when not hovered
  useEffect(() => {
    if (isPaused || count <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % count);
    }, 6000);
    return () => clearInterval(interval);
  }, [isPaused, count]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + count) % count);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % count);
  };

  const getItemAt = (offset) => items[(currentIndex + offset) % count];

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    setIsPaused(true);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = e.changedTouches[0].clientX - touchStartX.current;
    if (diff > 40) {
      handlePrev();
    } else if (diff < -40) {
      handleNext();
    }
    touchStartX.current = null;
    setIsPaused(false);
  };

  return (
    <>
      <SEOHead
        title="Kundeanmeldelser | Djurs Massage"
        description="Læs hvad vores kunder siger om massage og zoneterapi hos Djurs Massage i Ryomgård. Høj tilfredshed, grundighed og mærkbar smertelindring."
        ogImage="https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/djurs-massage-klinik-ryomgaard.jpg"
      />

      {/* Clean page header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6">
        <div className="max-w-3xl">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1E3A5F] font-serif leading-tight">
            Kundeanmeldelser
          </h1>
          <p className="text-slate-700 text-sm sm:text-base mt-3 leading-relaxed font-normal">
            Læs hvad vores kunder fortæller om deres behandlinger hos Djurs Massage. Vi er stolte af vores kunders tilfredshed og arbejder hver dag for at give dig den bedst mulige oplevelse.
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <a
              href="https://www.facebook.com/djursmassage.dk"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-[#1E3A5F] text-white text-xs sm:text-sm font-semibold rounded-full hover:shadow-md transition-shadow"
            >
              <i className="fa-brands fa-facebook-f text-white" aria-hidden="true" />
              <span>Anmeld på Facebook</span>
            </a>
            <a
              href="https://maps.google.com/?q=Djurs+Massage+Poppelvej+52+8550+Ryomg%C3%A5rd"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-white border border-[#D8CDBE] text-[#1E3A5F] text-xs sm:text-sm font-semibold rounded-full hover:shadow-xs transition-shadow"
            >
              <i className="fa-brands fa-google text-[#C9A770]" aria-hidden="true" />
              <span>Anmeld på Google</span>
            </a>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs sm:text-sm font-semibold rounded-full transition-colors"
            >
              <span>Send feedback via kontakt</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Carousel Section with all reviews */}
      <div className="border-t border-[#E8E1D5] py-12 lg:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <div className="flex items-center text-[#C9A770]">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star text-sm" aria-hidden="true" />
                  ))}
                </div>
                <span className="text-xs sm:text-sm font-bold text-[#1E3A5F]">5.0 ud af 5 stjerner</span>
              </div>
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif">
                Hvad vores kunder siger
              </h2>
            </div>

            {/* Carousel navigation controls (no boxes) */}
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={handlePrev}
                className="p-2 text-[#1E3A5F] hover:text-black transition-colors"
                aria-label="Forrige anmeldelse"
              >
                <i className="fa-solid fa-arrow-left text-lg" aria-hidden="true" />
              </button>
              <button
                type="button"
                onClick={handleNext}
                className="p-2 text-[#1E3A5F] hover:text-black transition-colors"
                aria-label="Næste anmeldelse"
              >
                <i className="fa-solid fa-arrow-right text-lg" aria-hidden="true" />
              </button>
            </div>
          </div>

          {/* Carousel viewport - 3 cols desktop, 2 tablet, 1 mobile */}
          <div
            className="relative select-none"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {/* Desktop (3 columns) */}
            <div className="hidden lg:grid lg:grid-cols-3 gap-6">
              {[0, 1, 2].map((offset) => {
                const rev = getItemAt(offset);
                return (
                  <div
                    key={`desktop-${currentIndex}-${offset}`}
                    className="group bg-white p-7 border border-[#E8E1D5] hover:shadow-xl transition-all duration-300 flex flex-col justify-between min-h-[260px]"
                  >
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-1 text-[#C9A770]">
                          {[...Array(rev.rating || 5)].map((_, i) => (
                            <i key={i} className="fa-solid fa-star text-sm" aria-hidden="true" />
                          ))}
                        </div>
                        <i className="fa-solid fa-quote-right text-slate-300 text-xl" aria-hidden="true" />
                      </div>
                      <p className="text-slate-700 group-hover:text-black transition-colors text-sm sm:text-base leading-relaxed italic mb-6">
                        "{rev.comment}"
                      </p>
                    </div>
                    <div className="pt-4 border-t border-[#F2ECE3] flex items-center justify-between text-xs sm:text-sm">
                      <span className="font-bold text-[#1E3A5F] group-hover:text-black transition-colors">
                        {rev.name}
                      </span>
                      {rev.date_info && (
                        <span className="text-slate-400">{rev.date_info}</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Tablet (2 columns) */}
            <div className="hidden sm:grid lg:hidden sm:grid-cols-2 gap-6">
              {[0, 1].map((offset) => {
                const rev = getItemAt(offset);
                return (
                  <div
                    key={`tablet-${currentIndex}-${offset}`}
                    className="group bg-white p-6 border border-[#E8E1D5] hover:shadow-xl transition-all duration-300 flex flex-col justify-between min-h-[250px]"
                  >
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-1 text-[#C9A770]">
                          {[...Array(rev.rating || 5)].map((_, i) => (
                            <i key={i} className="fa-solid fa-star text-sm" aria-hidden="true" />
                          ))}
                        </div>
                        <i className="fa-solid fa-quote-right text-slate-300 text-xl" aria-hidden="true" />
                      </div>
                      <p className="text-slate-700 group-hover:text-black transition-colors text-sm leading-relaxed italic mb-6">
                        "{rev.comment}"
                      </p>
                    </div>
                    <div className="pt-4 border-t border-[#F2ECE3] flex items-center justify-between text-xs">
                      <span className="font-bold text-[#1E3A5F] group-hover:text-black transition-colors">
                        {rev.name}
                      </span>
                      {rev.date_info && (
                        <span className="text-slate-400">{rev.date_info}</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Mobile (1 column) */}
            <div className="block sm:hidden">
              {(() => {
                const rev = getItemAt(0);
                return (
                  <div className="group bg-white p-6 border border-[#E8E1D5] shadow-sm flex flex-col justify-between min-h-[240px]">
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-1 text-[#C9A770]">
                          {[...Array(rev.rating || 5)].map((_, i) => (
                            <i key={i} className="fa-solid fa-star text-xs" aria-hidden="true" />
                          ))}
                        </div>
                        <i className="fa-solid fa-quote-right text-slate-300 text-lg" aria-hidden="true" />
                      </div>
                      <p className="text-slate-700 text-sm leading-relaxed italic mb-4">
                        "{rev.comment}"
                      </p>
                    </div>
                    <div className="pt-3 border-t border-[#F2ECE3] flex items-center justify-between text-xs">
                      <span className="font-bold text-[#1E3A5F]">{rev.name}</span>
                      {rev.date_info && (
                        <span className="text-slate-400">{rev.date_info}</span>
                      )}
                    </div>
                  </div>
                );
              })()}
            </div>

            {/* Indicators */}
            <div className="flex justify-center items-center gap-1.5 mt-8">
              {items.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentIndex(idx)}
                  className={`h-1.5 transition-all ${
                    idx === currentIndex
                      ? 'w-7 bg-[#1E3A5F]'
                      : 'w-2 bg-slate-300 hover:bg-slate-400'
                  }`}
                  aria-label={`Gå til anmeldelse ${idx + 1}`}
                />
              ))}
            </div>
          </div>

          {/* CTA Box under carousel */}
          <div className="mt-14 pt-8 border-t border-[#E8E1D5] max-w-xl">
            <h3 className="text-lg sm:text-xl font-bold text-[#1E3A5F] font-serif mb-2">
              Vil du dele din oplevelse?
            </h3>
            <p className="text-xs sm:text-sm text-slate-700 leading-relaxed mb-4">
              Vi sætter kæmpestor pris på din mening! Du kan anmelde os direkte på vores officielle Facebook-side, eller lægge en anmeldelse på Google.
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <a
                href="https://www.facebook.com/djursmassage.dk"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#1E3A5F] text-white text-xs sm:text-sm font-semibold rounded-full hover:shadow-md transition-shadow"
              >
                <i className="fa-brands fa-facebook-f text-white" aria-hidden="true" />
                <span>Skriv på Facebook</span>
              </a>
              <a
                href="https://maps.google.com/?q=Djurs+Massage+Poppelvej+52+8550+Ryomg%C3%A5rd"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-[#D8CDBE] text-[#1E3A5F] text-xs sm:text-sm font-semibold rounded-full hover:shadow-xs transition-shadow"
              >
                <i className="fa-brands fa-google text-[#C9A770]" aria-hidden="true" />
                <span>Skriv på Google</span>
              </a>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-transparent hover:bg-transparent text-[#1E3A5F] hover:text-black border border-[#1E3A5F] text-xs sm:text-sm font-semibold rounded-full transition-colors"
              >
                <span>Gå til kontaktsiden</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
